<template>
  <div>
    <l-marker
      v-for="(place, index) in validPlaces"
      :key="index"
      :lat-lng="[place.geometry[0], place.geometry[1]]"
      :icon="markerIcon"
    >
      <l-popup>{{ place.name }}</l-popup>
    </l-marker>
  </div>
</template>

<script>
import { LMarker, LPopup } from '@vue-leaflet/vue-leaflet'

export default {
  name: 'MarkersPage',
  components: {
    LMarker,
    LPopup,
  },
  props: {
    places: {
      type: Array,
      required: true,
      default: () => [],
    },
    markerIcon: {
      type: Object,
      default: null,
    },
  },
  computed: {
    validPlaces() {
      return Array.isArray(this.places)
        ? this.places.filter(
            (p) =>
              Array.isArray(p.geometry) &&
              p.geometry.length === 2 &&
              typeof p.geometry[0] === 'number' &&
              typeof p.geometry[1] === 'number'
          )
        : []
    },
  },
}
</script>
